import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import useFetch from '../../common/useFetch';
import DrawService from '../../domain/DrawService';
import gs from '../../styles/style';
import Breadcrumbs from '../Common/Breadcrumbs';
import DateTime from '../Common/DateTime';
import { useForm } from '../Common/Form';
import Loader from '../Common/Loader';
import DrawForm from './DrawForm';
var EditDrawForm = function (_a) {
    var history = _a.history, match = _a.match;
    var t = useTranslation()[0];
    var form = useForm({
        onSubmit: DrawService.editDraw,
        onSuccess: function (draw) { return history.push("/draws/".concat(draw.id)); }
    });
    var _b = useFetch(function (config) { return DrawService.getDraw(match.params.draw, config); }, {
        onSuccess: function (draw) {
            form.initValues(draw);
            setLoading(false);
        }
    }), draw = _b.data, getDraw = _b.get;
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    useEffect(function () {
        getDraw();
    }, []);
    if (loading) {
        return React.createElement(Loader, null);
    }
    return React.createElement("div", null,
        React.createElement(Breadcrumbs, null,
            React.createElement(Link, { to: "/draws" }, t('draws')),
            React.createElement(Link, { to: "/draws/".concat(draw.id) },
                React.createElement(DateTime, { date: draw.draw_at }))),
        React.createElement("div", { className: gs('section-header') },
            React.createElement("h1", { className: gs('section-title') }, t('edit_draw'))),
        React.createElement(DrawForm, { form: form }));
};
export default withRouter(EditDrawForm);
